/* Built In Imports */

/* External Imports */
import { Box, Flex, Skeleton, Text } from '@chakra-ui/react';

/* Internal Imports */
// Components
import SectionUI from './SectionUI';
import StyleConfig from './StyleConfig';
import Testimonials from '@app-kb/Components/Slider/Testimonials';
import { Suspense } from 'react';
import TopBannerKarma from '../Components/TopBannerKarma';
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import KarmaLeftSliderCardContent from '../Components/KarmaLeftSliderCardContent';
import KarmaRightSliderCardContent from '../Components/KarmaRightSliderCardContent';
import AvailableStores from '../Components/AvailableStores';
import QuizSection from '@landing_pages/karma/QuizSection';
import TopBannerKarmaBook from '../Components/TopBannerKarmaBook';
import BestSeller from '../Components/BestSeller';
import KarmaBookExcerpt from '../Components/KarmaBookExcerpt';
import KarmaSliderComponent from '../Components/KarmaSliderComponent';
import KarmaBlogCategoryExplain from '../Components/KarmaBlogCategoryExplain';
import KarmaBookInfo from '../Components/KarmaBookInfo';
import ExploreMenu from '../Components/ExploreMenu';
import AllBlogsList from '../Components/AllBlogsList';
import StructuredDataInsert from '../Components/StructuredDataInsert';

/**
 * Renders Render Sections
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.pType
 * @param sectionContent.csrData
 * @param sectionContent.pageData
 * @returns {ReactElement} Render Sections
 */
const RenderSections = ({
  section,
  region,
  lang,
  pType,
  csrData,
  pageData,
  headerMenuData,
}) => {
  const { sectionId } = section;
  // console.log(pageData, 'dkdfmdk');

  if (sectionId === 'top-banner') {
    return <TopBannerKarma sectionContent={section?.sectionContent} />
  }
  else if (sectionId === 'karma-quote') {
    return <Box
      bgImage={section?.styleConfig?.bgImage?.url}
      height={{ base: '359px', md: '450px', 'lg': '515px' }}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      bgColor={'#FFFFFF'}
      bgBlendMode={'multiply'}
    >
      <Text fontFamily={'var(--AustinMedium)'} width={{ base: '320px', 'md': '724px', lg: '850px' }} color={'#B7870C'} fontSize={{ base: '30px', md: '40px', lg: '50px' }} lineHeight={{ base: '38px', md: '60px' }} textAlign={'center'}
      fontWeight={'500'}>
        {section?.sectionContent?.[0]?.quote}
      </Text>
      <Box
        pt={'40px'}
        width={{ 'md': '150px' }}>
        <LazyLoadImageComponent
          src={section?.sectionContent?.[1]?.image?.url}
        />
      </Box>
    </Box>
  }
  else if (sectionId === 'karma-left' || sectionId === 'why-karma') {
    return <KarmaLeftSliderCardContent
      sectionContent={section?.sectionContent}
      styleConfig={section?.styleConfig}
      sectionId={sectionId}
    />
  }
  else if (sectionId === 'karma-right') {
    return <KarmaRightSliderCardContent
      sectionContent={section?.sectionContent}
      styleConfig={section?.styleConfig}
    />
  }
  else if (sectionId === 'available-stores') {
    return <AvailableStores
      sectionContent={section?.sectionContent}
      sectionId={sectionId}
      styleConfig={section?.styleConfig}
    />
  }
  else if (sectionId === 'karma-myth-or-fact') {
    return <Box>
       <QuizSection />
    </Box>
  }
  else if (sectionId === 'top-banner-book') {
    return <TopBannerKarmaBook sectionContent={section?.sectionContent} />
  }
  else if (sectionId === 'best-seller') {
    return <BestSeller sectionContent={section?.sectionContent} />
  }
  else if (sectionId === 'excerpt-book') {
    return <KarmaBookExcerpt sectionContent={section?.sectionContent}
      styleConfig={section?.styleConfig}
      sectionId={sectionId} />
  }
  else if (sectionId === 'testimonials') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        style={section.styleConfig}
        section={section}
        lang={lang}
        region={region}
      >
        <Testimonials
          sectionContent={section?.sectionContent}
          lang={lang}
          region={region}
        />
      </StyleConfig>
    );
  }
  else if (sectionId === 'karma-book-slider') {
    return <Box
      w={'100%'}
      display={'flex'}
      pt={{ base: '50px', md: '90px', xl: '100px' }}
      pb={{ base: '50px', md: '90px', xl: '100px' }}
      bgImage={section?.styleConfig?.bgImage?.url}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <KarmaSliderComponent sectionContent={section?.sectionContent?.[0]}
        width={{ base: '320px', md: '658px', lg: '658px', 'xl': '1000px' }}
        height={{ base: '180px', md: '395px', lg: '395px', 'xl': '600px' }}
        prevArrRightPos={{ base: '-0.5rem', md: '-1.2rem' }}
        nextArrRightPos={{ base: '-0.5rem', md: '-1.2rem' }}
      />
    </Box>
  }
  else if (sectionId === 'blog-category-explain') {
    return <KarmaBlogCategoryExplain sectionContent={section?.sectionContent} />
  }
  else if (sectionId === 'karma-book-info') {
    return <KarmaBookInfo 
    sectionContent={section?.sectionContent}
    styleConfig={section?.styleConfig} />
  }
  else if (sectionId === 'explore-more'){
    return <ExploreMenu secContent={section?.sectionContent}/>
  }
  else if (sectionId === 'allBlogsList'){
    return <AllBlogsList sectionContent={section} />
  }
  else if (sectionId === 'structured-data' ) { 
      return <StructuredDataInsert data={JSON.parse(section?.sectionContent?.[0]?.text)} />
  }
  else {
    return (
      <Box as="div" display="block" placeContent="center" w="100%">
        <Suspense fallback={<Skeleton />}>
          {section?.sectionContent?.length > 0
            ? section?.sectionContent?.map((secCon, i) => {
              return (
                <StyleConfig
                  id={section?.sectionId}
                  key={section?.sectionId}
                  style={section?.styleConfig}
                  section={section}
                  // pT="0"
                  pB={{ base: '0', md: '15px' }}
                  // mB="0"
                  lang={lang}
                  region={region}
                >
                  <SectionUI
                    key={i}
                    sectionContent={secCon}
                    section={section}
                    region={region}
                    lang={lang}
                    pType={pType}
                    csrData={csrData}
                    pageData={pageData}
                    headerMenuData={headerMenuData}
                  />
                </StyleConfig>
              );
            })
            : null}
        </Suspense>
      </Box>
    );
  }
};

export default RenderSections;
